(function()
{
	function ViewTransition()
	{
		this.Container_constructor();
		this.visible = false;
	}

	var p = createjs.extend(ViewTransition, cjs.Container);

	p.build = function()
	{
		var shape = new cjs.Shape().set({regX:cm.System.maxWidth * 0.5, regY:cm.System.height * 0.5});
		shape.graphics.f("#000").r(0,0,cm.System.maxWidth,cm.System.height);
		this.addChild(shape);
	};

	p.transitIn = function()
	{
		var tween = cjs.Tween.get(this, {override:true})
			.wait(100)
			.to({alpha:0}, 400, cjs.Ease.quadInOut)
			.set({visible:false});
		return tween.duration;
	};

	p.transitOut = function()
	{
		this.alpha = 0;
		var tween = cjs.Tween.get(this, {override:true})
			.set({visible:true})
			.to({alpha:1}, 400, cjs.Ease.quadInOut);
		return tween.duration;
	};

	cm.ViewTransition = cjs.promote(ViewTransition, "Container");
})();